import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqContaSaida = {
	listPaginate: async function (body) {
		return apiServer
			.get("portal/v1/conta-saida", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/conta-saida/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listIDGroup: async function (id) {
		return apiServer
			.get(`portal/v1/conta-saida/${id}/conta-saida-grupo`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/conta-saida", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listMovement: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/contasaida/movimentacao", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listCategoria: async function (param, dtIni, dtFim) {
		return apiServer
			.get("portal/v1/relatorios/conta-saida/categoria", {
				params: {
					param,
					dtIni,
					dtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqContaSaida;
